const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"SehDeOl0k8QVUevfAuO-V"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["johana@mangoweb"]={id:"SehDeOl0k8QVUevfAuO-V"};
      